import { render } from "./Alpha.vue?vue&type=template&id=1d741f72"
import script from "./Alpha.vue?vue&type=script&lang=js"
export * from "./Alpha.vue?vue&type=script&lang=js"

import "./Alpha.vue?vue&type=style&index=0&id=1d741f72&lang=css"
script.render = render

export default script